import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { RequestBuilderService } from '../../../../shared/services/request-builder.service';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-reset-stop-dialog',
  standalone: true,
  imports: [FormsModule, ButtonComponent, AutoCompleteModule],
  templateUrl: './reset-stop-dialog.component.html',
  styleUrl: './reset-stop-dialog.component.scss',
})
export class ResetStopDialogComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);

  loading = false;
  reason: string = '';
  suggestions: string[] = [`Driver updated student's status by mistake.`, `Driver updated student's status incorrectly.`];
  filteredSuggestions: string[] = [];

  ngOnInit() {
    this.filteredSuggestions = [...this.suggestions];
  }

  filterSuggestions(event: any, autoComplete: AutoComplete) {
    if (this.reason) {
      this.filteredSuggestions = this.suggestions.filter(suggestion => suggestion.toLowerCase().includes(this.reason.toLowerCase()));
    } else {
      this.filteredSuggestions = [...this.suggestions];
      if (this.filteredSuggestions.length > 0) {
        autoComplete.show();
      }
    }
  }

  confirmAction(form: NgForm) {
    if (form?.invalid || this.loading) return;

    this.loading = true;

    const body = {
      internalNote: form.form.value.reason,
    };
    this.requestBuilder.patch(`stops/rides/${this.config.data.uuid}/stops/${this.config.data.stop.stopId}/reset`, body).subscribe({
      next: () => {
        this.loading = false;
        this.ref.close({ confirmed: true });
      },
      error: error => {
        this.loading = false;
      },
    });
  }
}
